<script>
import {environment} from '@app/store/envStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js'

import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    markerState
} from '@app/store/markerStore.svelte.js';
import {
    issueState
} from '@app/store/issueStore.svelte.js';
import {
    speakerState
} from '@app/store/speakerStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import { can } from "@app/lib/entitlements.js";
import {
    metadataState
} from '@app/store/metadataStore.svelte.js';
import {
    styleState
} from '@app/store/styleStore.svelte.js';

import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    fade
} from 'svelte/transition';

import {
    saveAs
} from 'file-saver';
import { ccprjFunc } from '@app/lib/ccprj.js';
import * as m from "@app/paraglide/messages.js";

function exportProject() {
    let projectJson = ccprjFunc.createCcprj({
        project : JSON.parse(JSON.stringify(projectState)),
        metadata : JSON.parse(JSON.stringify(metadataState)),
        speakers : JSON.parse(JSON.stringify(speakerState)),
        issues : JSON.parse(JSON.stringify(issueState.value)),
        markers : JSON.parse(JSON.stringify(markerState)),
        eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
        style : JSON.parse(JSON.stringify(styleState))
    });

    console.log(projectJson.issues);
    console.log(projectJson);

    let fileBlob = new Blob([JSON.stringify(projectJson, null, 4)], {
        type: "text/plain;charset=utf-8"
    });

    saveAs(fileBlob, projectState.name + ".ccprj", {
        autoBom: true
    });

    hideModal();
}
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'fileExport' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="exportTitle"
    aria-modal="true"
    tabindex="-1" 
    id="ExportModal">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exportTitle">{m.file_export_title()}</h4>
                <button type="button" 
                    class="btn-close" 
                    aria-label={m.file_export_close_label()} 
                    onclick={hideModal}>
                </button>
            </div>
            <div class="modal-body">
                <div class="row row-cols-1 row-cols-md-3 g-3">
                    {#if environment.electron}
                        <div class="col">
                            <button type="button" 
                                class="card h-100 action-card btn p-0 w-100" 
                                onclick={() => showModal('videoExport')}
                                aria-label={m.file_export_video_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-camera-video fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_video_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_video_desc()}</p>
                                </div>
                            </button>
                        </div>
                    {/if}
                    {#if environment.electron && authState.ad && environment.online}
                        <div class="col">
                            <button type="button" 
                                class="card h-100 action-card btn p-0 w-100" 
                                onclick={() => showModal('audioDescriptionExport')}
                                aria-label={m.file_export_audio_description_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-mic fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_audio_description_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_audio_description_desc()}</p>
                                </div>
                            </button>
                        </div>
                        <div class="col">
                            <button type="button" 
                                class="card h-100 action-card btn p-0 w-100" 
                                onclick={() => showModal('audioDubbingExport')}
                                aria-label={m.file_export_audio_dubbing_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-soundwave fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_audio_dubbing_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_audio_dubbing_desc()}</p>
                                </div>
                            </button>
                        </div>
                    {/if}
                    {#if environment.electron && authState.ad}
                        <div class="col">
                            <button type="button" 
                                class="card h-100 action-card btn p-0 w-100" 
                                onclick={() => showModal('audioEmbedExport')}
                                aria-label={m.file_export_audio_embed_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-soundwave fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_audio_embed_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_audio_embed_desc()}</p>
                                </div>
                            </button>
                        </div>
                    {/if}
                    <!-- Offline, the desktop app can still embed with the Local option -->
                    {#if can("embed608") && (environment.online || environment.electron)}
                        <div class="col">
                            <button type="button"
                                class="card h-100 action-card btn p-0 w-100"
                                onclick={() => showModal('embedCaptionsExport')}
                                aria-label={m.file_export_embed_captions_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-badge-cc fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_embed_captions_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_embed_captions_desc()}</p>
                                </div>
                            </button>
                        </div>
                    {/if}
                    {#if environment.electron}
                        <div class="col">
                            <button type="button" 
                                class="card h-100 action-card btn p-0 w-100" 
                                onclick={() => showModal('imageExport')}
                                aria-label={m.file_export_image_subtitles_aria()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-image fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title">{m.file_export_image_subtitles_title()}</h5>
                                    <p class="card-text small text-muted">{m.file_export_image_subtitles_desc()}</p>
                                </div>
                            </button>
                        </div>
                    {/if}
                    <div class="col">
                        <button type="button" 
                            class="card h-100 action-card btn p-0 w-100" 
                            onclick={() => showModal('subtitleExport')}
                            aria-label={m.file_export_subtitle_file_aria()}>
                            <div class="card-body text-center py-4">
                                <i class="bi bi-file-text fs-2 mb-2" aria-hidden="true"></i>
                                <h5 class="card-title">{m.file_export_subtitle_file_title()}</h5>
                                <p class="card-text small text-muted">{m.file_export_subtitle_file_desc()}</p>
                            </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button" 
                            class="card h-100 action-card btn p-0 w-100" 
                            onclick={() => showModal('transcriptExport')}
                            aria-label={m.file_export_transcript_aria()}>
                            <div class="card-body text-center py-4">
                                <i class="bi bi-file-earmark-text fs-2 mb-2" aria-hidden="true"></i>
                                <h5 class="card-title">{m.file_export_transcript_title()}</h5>
                                <p class="card-text small text-muted">{m.file_export_transcript_desc()}</p>
                            </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button" 
                            class="card h-100 action-card btn p-0 w-100" 
                            onclick={() => showModal('dialogueListExport')}
                            aria-label={m.file_export_dialogue_list_aria()}>
                            <div class="card-body text-center py-4">
                                <i class="bi bi-people fs-2 mb-2" aria-hidden="true"></i>
                                <h5 class="card-title">{m.file_export_dialogue_list_title()}</h5>
                                <p class="card-text small text-muted">{m.file_export_dialogue_list_desc()}</p>
                            </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button" 
                            class="card h-100 action-card btn p-0 w-100" 
                            onclick={() => showModal('ccslExport')}
                            aria-label={m.file_export_ccsl_aria()}>
                            <div class="card-body text-center py-4">
                                <i class="bi bi-file-earmark-richtext fs-2 mb-2" aria-hidden="true"></i>
                                <h5 class="card-title">{m.file_export_ccsl_title()}</h5>
                                <p class="card-text small text-muted">{m.file_export_ccsl_desc()}</p>
                            </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button" 
                            class="card h-100 action-card btn p-0 w-100" 
                            onclick={exportProject}
                            aria-label={m.file_export_project_file_aria()}>
                            <div class="card-body text-center py-4">
                                <i class="bi bi-folder fs-2 mb-2" aria-hidden="true"></i>
                                <h5 class="card-title">{m.file_export_project_file_title()}</h5>
                                <p class="card-text small text-muted">{m.file_export_project_file_desc()}</p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .action-card {
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        border: none;
        background: linear-gradient(135deg, var(--bs-body-bg) 0%, var(--bs-light-bg-subtle) 100%);
        border-radius: 1rem;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
        display: block;
        text-align: center;
        font-weight: normal;
        position: relative;
        overflow: hidden;
    }

    .action-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, var(--bs-primary) 0%, color-mix(in srgb, var(--bs-primary) 70%, black) 100%);
        opacity: 0;
        transition: opacity 0.4s ease;
        border-radius: 1rem;
    }

    .action-card:hover {
        transform: translateY(-4px) scale(1.02);
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
    }

    .action-card:hover::before {
        opacity: 1;
    }

    .action-card .card-body {
        position: relative;
        z-index: 1;
    }

    .action-card i,
    .action-card .card-title {
        transition: all 0.4s ease;
    }

    .action-card:hover i,
    .action-card:hover .card-title {
        color: white;
        transform: scale(1.1);
    }

    .action-card:hover .card-text {
        color: rgba(255, 255, 255, 0.85) !important;
    }

    .action-card:focus {
        outline: 2px solid var(--bs-primary);
        outline-offset: 2px;
    }
</style>
